export default __webpack_public_path__ + "static/panoramic3-a03f069ba28c5ad199ed72ba5e0a4f50.jpg";